import { render, staticRenderFns } from "./TextLink.vue?vue&type=template&id=54b060a6&"
import script from "./TextLink.vue?vue&type=script&lang=js&"
export * from "./TextLink.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/app.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports